@if (timeOut()) {
  <app-timeout></app-timeout>
} @else {
  @if (loading()) {
    <div class="h-full flex justify-content-center align-items-center">
      <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
    </div>
  } @else {
    <p-table
      [columns]="GATE_FAULTS_COLUMNS"
      [value]="displayedGateFaults() || []"
      [tableStyle]="{ 'table-layout': 'fixed', width: '100%' }"
      class="p-1 fullTable tableHeaderAlignTop"
    >
      <ng-template #header let-columns>
        <tr>
          @for (col of columns; track col) {
            <th [class]="col.field + '-column'">
              {{ col.header | translate }}
            </th>
          }
          <th class="detailButton-column"></th>
        </tr>
      </ng-template>

      <ng-template #body let-rowData let-columns="columns">
        <tr class="pointer" role="button" (click)="openDetails(rowData, getDialogType(rowData))">
          @for (col of columns; track col) {
            <td [class]="col.field + '-column'">
              @switch (col.field) {
                @case ("gateSystem") {
                  <span class="gate-cell">
                    <span
                      [class]="'faultPoint ' + rowData.faultType"
                      [pTooltip]="'gate_faults.severity.' + rowData.faultType | translate"
                      tooltipPosition="bottom"
                    ></span>
                    <span
                      class="gate-name"
                      [pTooltip]="
                        gateIdentifierPipe.transform(
                          rowData.gateSystem,
                          permissions.hasPermission(permissions.allPermissions.ASSET_MASTER_DATA_CREATE)
                        )
                      "
                    >
                      {{ rowData.gateSystem.label }}...
                    </span>
                  </span>
                }
                @case ("faultText") {
                  <span class="fault-description">{{ rowData[col.field] }}</span>
                }
                @case ("repairStatus") {
                  @if (rowData[col.field]) {
                    {{ "gate_faults.repair_status" + (rowData[col.field] | repairStatus) | translate }}
                  } @else {
                    {{ "gate_faults.repair_status.none" | translate }}
                  }
                }
                @default {
                  {{ rowData[col.field] }}
                }
              }
            </td>
          }
          <td class="detailButton-column">
            @if (
              !rowData.repairStatus ||
              rowData.repairStatus === repairStatuses.None ||
              rowData.repairStatus === repairStatuses.Archived
            ) {
              <app-svg-icon
                *appHasPermission="{
                  permissions: [permissions.allPermissions.DASHBOARD_READ],
                  missingPermission: permissions.allPermissions.REPAIR_REQUEST_CREATE,
                }"
                iconName="eye"
                iconColor="primary"
                class="pointer"
                (click)="openDetails(rowData, 'details')"
              ></app-svg-icon>
              <app-svg-icon
                *appHasPermission="{
                  permissions: [permissions.allPermissions.REPAIR_REQUEST_CREATE],
                }"
                iconName="repair"
                iconColor="primary"
                class="pointer"
                (click)="openDetails(rowData, 'request')"
              ></app-svg-icon>
            }
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
}
